module.exports = __webpack_public_path__ + "assets/img/wback0.ddb355cc.png";